import styled from "styled-components";
import { Flex } from "grid-styled";

export const CardContent = styled(Flex)``;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DriverWarningContainer = styled(Flex)`
  background-color: #f9fbfb;
  border-radius: 10px;
  width: 300px;
  margin-bottom: 8px;
`;
